import Vue from 'vue';

export class RST {

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static byPK(idRastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('configuracao-rst/by-pk/' + idRastreador)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static sendIbutton(idRastreador, json){
        return Vue.http.post('configuracao-rst/ibutton/' + idRastreador, json);
    }

    static sendIpPorta(idRastreador, json){
        return Vue.http.post('configuracao-rst/ip/' + idRastreador, json);
    }

    static sendIpPortaAll(idRastreador, json){
        return Vue.http.post('configuracao-rst/ip/' + idRastreador + '/all', json);
    }

    static clearIbutton(idRastreador, json){
        return Vue.http.post('configuracao-rst/ibutton/' + idRastreador + '/apagar', json);
    }

    static solicitarIbuttons(idRastreador){
        return Vue.http.post('configuracao-rst/ibutton/' + idRastreador + '/buscar', {});
    }

}
